import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent implements OnInit {

  @Input() values;

  constructor() { }

  ngOnInit() {
  }

  getMargin() {
    return Math.floor(Math.random() * 10) + 2;
  }
}
